(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings-panel/communication-settings-service.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings-panel/communication-settings-service.js');
"use strict";


const jupiter = svs.core.jupiter;

const getCustomersPropertiesAsync = async () => {
  svs.myProfile.logger.debug('CommunicationSettingsService:getCustomersPropertiesAsync start...');
  try {
    const path = '/player/1/properties'; 
    const _await$jupiter$callAs = await jupiter.callAsync({
        method: 'GET',
        path,
        data: {}
      }),
      response = _await$jupiter$callAs.response;
    svs.myProfile.logger.debug('CommunicationSettingsService:getCustomersPropertiesAsync response from jupiter');
    return {
      error: response === null || response === void 0 ? void 0 : response.error,
      playerProperties: response === null || response === void 0 ? void 0 : response.playerProperties
    };
  } catch (err) {
    svs.myProfile.logger.error('CommunicationSettingsService:getCustomersPropertiesAsync error response from jupiter:', err);
    return {
      error: err,
      playerProperties: {}
    };
  }
};
svs.myProfile.react.pages.communicationSettings.communicationSettings.communicationSettingsService = {
  getCustomersPropertiesAsync
};

 })(window);